import type { TruevaultOnboardingProgress } from "../../../common/hooks/useOnboardingProgress";

// Removing data from the data map strips it from every retention purpose, so an approved purpose
// can be left with no data categories. It then drops out of the privacy policy, and nothing tells
// a customer who finished setup long ago. Only the builder's policy is checked (not a custom
// retention section).
export const shouldShowRetentionPolicyUpdateAlert = (
  onboardingProgress: TruevaultOnboardingProgress | undefined,
  isAllOnboardingComplete: boolean,
): boolean =>
  isAllOnboardingComplete &&
  onboardingProgress?.dataMapOnboardingProgress?.hasRetentionPurposesWithoutCategories === true;
